import * as math from "mathjs";

// 加法解决精度问题
export function arithmeticAdd(num1, num2) {
  return Number(math.add(math.bignumber(num1), math.bignumber(num2)));
}

// 减法解决精度问题
export function arithmeticSubtract(num1, num2) {
  return Number(math.subtract(math.bignumber(num1), math.bignumber(num2)));
}

// 乘法
export function arithmeticMultiply(num1, num2) {
  return Number(math.multiply(math.bignumber(num1), math.bignumber(num2)));
}

// 除法
export function arithmeticDivide(num1, num2) {
  return Number(math.divide(math.bignumber(num1), math.bignumber(num2)));
}

/**
 * epsg:4326转epsg:3857
 * @param {经纬度[104.06321086770868, 30.539527398871428]} latlng
 * @param {转换前坐标系} beforeEpsg
 * @param {转换后坐标系} afterEpsg
 * @returns
 */
export function coordinateConversion(latlng, beforeEpsg, afterEpsg) {
  return ol.proj.transform(latlng, `EPSG:${beforeEpsg}`, `EPSG:${afterEpsg}`);
}
/**
 * 根据距离获取地图层级
 * @param {距离单位m} distance
 * @returns
 */
export function getZoom(distance) {
  let zooms = [
    50,
    100,
    200,
    500,
    1000,
    2000,
    5000,
    10000,
    20000,
    25000,
    50000,
    100000,
    200000,
    500000,
    1000000,
    2000000,
  ];
  for (let [index, i] of zooms.entries()) {
    if (i - distance > 0) {
      let zoom = 18 - index + 3;
      return zoom;
    }
  }
}

/**
 * 判断地址是视频还是图片还是其他
 * @param {url地址} url
 */
export function imgOrVideo(url) {
  let imgSuffix = [
    "png",
    "jpg",
    "jpeg",
    "bmp",
    "gif",
    "pic",
    "svg",
    "heic",
    "jfif",
    "JFIF",
    "HEIC",
    "SVG",
    "PNG",
    "JPG",
    "JPEG",
    "BMP",
    "GIF",
    "PIC",
  ];
  let videoSuffix = [
    "avi",
    "flv",
    "mpg",
    "mpeg",
    "mpe",
    "m1v",
    "m2v",
    "mpv2",
    "mp2v",
    "dat",
    "ts",
    "tp",
    "tpr",
    "pva",
    "pss",
    "mp4",
    "m4v",
    "m4p",
    "m4b",
    "3gp",
    "3gpp",
    "3g2",
    "3gp2",
    "ogg",
    "mov",
    "qt",
    "rm",
    "ram",
    "rmvb",
    "rpm",
    "wmv",
    "asf",
    "asx",
    "mkv",
    "vob",
    "mod",
    "dv",
  ];
  let audioSuffix=[
    'm4a',
    'aac',
    'mp3',
    'ogg',
    'flac',
  ]
  let suffix = url.split(".")[url.split(".").length - 1].split('?')[0];
  // console.log(suffix)
  // for (let i of audioSuffix){
    if (audioSuffix.includes(suffix.toLowerCase())){
      let returnUrl=url.split('?')[0]
      return { type: "audio", url:returnUrl };
    } 
  // }
  // for (let i of imgSuffix) {
    else if (imgSuffix.includes(suffix.toLowerCase())) return { type: "img", url };
  // }
  // for (let i of videoSuffix) {
    // 视频封面图
    else if (videoSuffix.includes(suffix.toLowerCase())){
      return {
        type: "video",
        url:
          url + "?x-oss-process=video/snapshot,t_2000,f_jpg,w_800,h_600,m_fast",
      };
    }else{
      // console.log(11111111)
      let returnUrl=url.split('?')[0]
      return {type:'download',url:returnUrl}
    } 
      
  // }
}
